var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",on:{"click":_vm.KelasMakMinData}},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-cubes"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }